import { gql } from '@apollo/client';

const POST_FIELDS = gql`
  fragment PostFields on PublishingPost {
    id
    type
    text
    status
    error {
      message
      link
      actionType
    }
    isReminder
    isCustomScheduled
    isPinned
    formattedTime
    isRetweet
    dueAt
    title
    createdBy
    needsApproval
    sourceUrl
    isBlueprint
    updateType
    threadCount
    channelData {
      googlebusiness {
        start_date
        end_date
        start_time
        end_time
        title
        code
        link
        terms
      }
      startPage {
        link
      }
      youtube {
        title
      }
    }
    statistics {
      retweets
      comments
      likes
      favorites
      mentions
      clicks
      reach_twitter
      reach
      shares
      reshares
      repins
      linkClicks
    }
    geoLocation {
      id
      text
    }
    channel {
      id
      service
      avatar
      username
      serverUrl
      locationData {
        location
      }
    }
    subprofile {
      id
      name
    }
    attachments {
      ... on PublishingPostLink {
        url
        title
        description
        thumbnail
      }
      ... on PublishingPostRetweet {
        avatar
        accountName
        username
        text
        url
        sentAt
      }
      ... on PublishingPostFirstComment {
        text
      }
      ... on PublishingPostDestinationUrl {
        url
      }
    }
    media {
      thumbnail
      type
    }
    campaign {
      name
      color {
        value
      }
    }
    serviceLink
  }
`;

export default POST_FIELDS;
